let timelineElements = [
  {
    id: 5,
    title: "Program Instructor Co-op",
    location: "McMaster Engineering Community Outreach",
    description:
      "Inspiring the future generations of engineers and STEAM leaders.",
    buttonText: "See Instagram Page",
    date: "May 2025 - Aug. 2025",
    icon: "work",
    link: "https://www.instagram.com/macengyouth/?hl=en",
  }
  ,{
    id: 4,
    title: "Full-stack Developer",
    location: "Google Developer Student Clubs @ McMaster",
    description:
      "Developing a user-friendly web application for ophthalmology image analysis, utilizing React and Tailwind CSS.",
    buttonText: "See GitHub Project",
    date: "September 2024 - May 2025",
    icon: "school",
    link: "https://github.com/DSC-McMaster-U/Ocular-Disease-Identifier",
  },
  {
    id: 3,
    title: "Software Developer",
    location: "McMaster Muslims Students' Association",
    description:
      "Creating an inventory database system and re-designing webpage using React and TypeScript.",
    buttonText: "See Club Website",
    date: "September 2024 - Present",
    icon: "school",
    link: "https://macmsa.com/",
  },
  {
    id: 2,
    title: "Web Developer Intern",
    location: "Blue Eclipse Inc.",
    description:
      "Developed functional and client-tailored websites using JS, HTML, and CSS to meet business requirements.",
    buttonText: "See Company Page",
    date: "May 2024 - August 2024",
    icon: "work",
    link: "https://blueeclipse.ca/",
  },
  {
    id: 1,
    title: "Software Engineering Intern",
    location: "Ada Analytics",
    description:
      "Conducted comprehensive testing on vital authentication-based functions using Pytest and PostgreSQL.",
    buttonText: "See Company Page",
    date: "January 2024 - April 2024",
    icon: "work",
    link: "https://adaanalytics.io/",
  },
];

export default timelineElements;
